import { useEffect, useRef, useState } from "react";
import general, { imgPlaceholder } from "../../general";
import { ShareAltOutlined } from "@ant-design/icons";
import {
  useLocalStorageState,
  useLockFn,
  useMount,
  useReactive,
  useScroll,
  useThrottleEffect,
  useThrottleFn,
  useUpdateEffect,
} from "ahooks";
import { useHistory, useLocation } from "react-router-dom";
import Index from "./detail/Index";
import Server from "./detail/Server";
import Comment from "./detail/Comment";
import ToolCabinet from "./detail/ToolCabinet";
import { Swiper, SwiperSlide } from "swiper/react";
import { CSSTransition } from "react-transition-group";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { NavLink } from "../../lib/Navigation";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import dayjs from "dayjs";
import useUrlState from "@ahooksjs/use-url-state";
import MobileDetect from "mobile-detect";
import URI from "urijs";
import qs from "qs";
import Super from "./ios/Super";
import Intercept from "./ios/Intercept";
import Require from "./ios/Require";
import Auto from "./ios/Auto";
import Active from "../../lib/Active";
import _ from "lodash";
import $ from "jquery";
import uni from "@dcloudio/uni-webview-js";
import CryptoJS from "crypto-js";
import { getUuidCallback, behaviorTrigger } from "../../utils/trigger";
import { asecAgentData } from "../../utils/asecData";
import { sortEncodeAndHash } from "../../utils/signFunc";
import Image from "../../lib/Image";
import { useLogin } from "../../lib/LoginContext";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import { Link } from "react-router-dom";
import { storageLocal } from "../../view/util/storage";

// 游戏详情页
const mobileDetect = new MobileDetect(navigator.userAgent);

const router = [
  {
    id: "index",
    component: Index,
    name: "详情",
  },
  {
    id: "comment",
    component: Comment,
    name: "评论有礼",
    count: "",
  },
  {
    id: "tool",
    component: ToolCabinet,
    name: "工具箱",
  },
];

const spm = (spm) => general.axios.post("/v3/spm", { spm });

export default (props) => {
  const history = useHistory();
  let [udid, setUdid] = useActiveState("udid");

  const { setShowLogin } = useLogin();

  const token = () => {
    let uri = new URI(window.location.hash.substring(1));
    let query = uri.query(true);

    if (query.appDownload && query.bd_vid) {
      storageLocal.set("bd_vid", query.bd_vid);
    }

    if (query.appDownload && query.uuid) {
      storageLocal.set("tgm_uuid", query.uuid);
    }

    if (query.appDownload && query.activeKid) {
      storageLocal.set("activeParentKid", query.activeKid);
    }

    if (
      query.udid &&
      (query.user_id || query.userid) &&
      query.username &&
      query.token
    ) {
      setUdid(query.udid);

      // 安装描述文件后 跳转回盒子时 此时用户绝对已签名
      // 获取
      console.log("安装描述文件成功回来啦~~~~~~~~", udid);

      localStorage.setItem("user_id", query.user_id);
      localStorage.setItem("username", query.username);
      localStorage.setItem("token", query.token);
      localStorage.setItem("key", query.key);
      storageLocal.set("bd_vid", query.bd_vid);
      storageLocal.set("tgm_uuid", query.uuid);
      storageLocal.set("activeParentKid", query.activeKid);

      if (!query.appDownload) {
        query.user_id = undefined;
        query.userid = undefined;
        query.username = undefined;
        query.token = undefined;

        uri.query(query);
        console.warn(uri.toString());
        history.replace(uri.toString());
      }
    }
  };
  useMount(token);
  useMount(history.listen(token));
  const [params] = useUrlState();
  const [config, setConfig] = useActiveState("config");
  const [key] = useActiveState("key");

  let [agent] = useActiveState("agent");
  useEffect(() => {
    props.setTitle("");
    props.setOperate(
      <CopyToClipboard
        text={window.location.href}
        onCopy={() => Dialog.info("已复制链接")}
      >
        <ShareAltOutlined />
      </CopyToClipboard>
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const [init, setInit] = useState(false);
  const [game, setGame] = useState(null);
  // 免签名下载按钮是否展示
  const [downloadSigning, setDownloadSigning] = useState(false);
  // 至尊版(需要超级签)下载按钮是否展示
  const [iosBtnShow, setIosBtnShow] = useState(false);

  let gameData = null;

  const load = (parms = {}) => {
    if (!params.isSearchLink) {
      storageLocal.remove("activeParentKid");
    }

    if (loading) {
      return;
    }
    setLoading(true);
    let data = {};
    if (props.query.id) {
      data.game_id = props.query.id;
    } else if (props.query.mid) {
      data.maiyou_gameid = props.query.mid;
    } else {
      Dialog.error("缺少参数", 1, () => history.goBack);
      return;
    }
    general.axios
      .post("/v3/base/game/getGameDetail", data)
      .then(async (res) => {
        console.log("详情游戏------", res);
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        // 安卓和H5游戏  new_sdk_version
        // iOS企业签游戏  selfsign_sdk_version
        // iOS超级签游戏  superSign_sdk_version

        let game = { ...data, ...data.game_info };
        if (game.game_feature_list) {
          let result = /<table[^>]*?>([\s\S]*)<\/table>/g.exec(
            game.game_feature_list[2].content
          );
          if (result && result[0]) {
            game.vipprice = result[0];
          }
        }
        if (game.status == 0) {
          game.cloud_support_type = "";
          game.cloudDisabled = 1;
        }

        if (game.game_species_type == 3) {
          if (!storageLocal.has("tgm_uuid")) {
            await getUuidCallback();
          }

          // h5游戏与云玩 暂不做处理
          let tgmudid = await asecAgentData("");

          let gameUrlH5 = game.game_url.android_url.split("&");
          gameUrlH5[1] = "agent=" + tgmudid;
          gameUrlH5 = gameUrlH5.join("&");
          console.log("tong----", gameUrlH5);

          game.game_url.android_url = gameUrlH5;
        }

        sessionStorage.setItem(
          "questionList",
          JSON.stringify(game.iosProblemData)
        );

        gameData = game;
        setGame(game);
        general.game = game;
        console.log("游戏详情", game);

        const navHeight =
          navRef.current?.getBoundingClientRect().height ||
          navRef.current?.clientHeight ||
          100;

        topHeight = navHeight;
        setTopHeight(navHeight);

        if (
          game?.cloud_support_type === "sq" &&
          game?.cloudDisabled === 0 &&
          props.query.cloudType === "start"
        ) {
          intercept("cloud", playCloudGame);
          spm(`game.${game?.maiyou_gameid}.cloud`);
        }

        setTimeout(() => {
          setLoading(false);
        }, 100);

        return general.axios.get("/v3/base/game/isshowselfsign", {
          params: {
            game_id: game?.maiyou_gameid,
          },
        });
      })
      .finally(() => { })
      .then((res) => {
        console.log("是否展示免签名包体", res, game);
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        if (game?.game_species_type != 3 && props.query.download) {
          if (data.show) {
            signingDownload();
          }

          if (data.iosshow) {
            downloadGame();
          }
        }

        setDownloadSigning(data.show);
        setIosBtnShow(data.iosshow);

        setInit(true);
      })
      .catch((err) => {
        // Dialog.error('getGameDetail ' + err.message);
      });

    if (storageLocal.has("tgm_uuid")) {
      behaviorTrigger("browsing");
    }

    getUdidVal();
    if (
      storageLocal.has("jjAgentShow") &&
      !storageLocal.has("isShowNewuserWelfare")
    ) {
      getPopup();
    }
  };

  const [newuserPopup, setNewuserPopup] = useState();
  const getPopup = () => {
    general.axios.post("/v3/movable/popup/popup").then(({ data: resData }) => {
      console.log("右下角悬浮球--------", resData);
      let { status, data } = resData;
      if (status.succeed) {
        if (
          storageLocal.has("jjAgentShow") &&
          data.title == "新人见面礼" &&
          data?.is_receive == 2
        ) {
          setNewuserPopup({ ...data });
          storageLocal.set("isShowNewuserWelfare", "yes");
        }
      }
    });
  };

  const playCloudGame = (spm = "normal", assign = null, desktop = false) => {
    general.referrer = window.location.href;
    history.push(
      `/game/cloud?${qs.stringify({
        id: gameData?.game_id || game?.game_id,
        agent: localStorage.getItem("agent") || "x7z1",
        user: localStorage.getItem("user_id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        version: gameData?.new_sdk_version || game?.new_sdk_version,
        spm,
        assign,
        auto: desktop ? "desktop" : null,
      })}`
    );
  };

  const [needLogin, setNeedLogin] = useState(false);
  // useEffect(async () => {
  //   let is_bind = await isCallFunc();
  //   setNeedLogin(is_bind);
  // }, []);

  useEffect(() => {
    load();
  }, [localStorage.getItem("token")]);

  const getUdidVal = async () => {
    if (key) {
      let userAgent = window.navigator.userAgent;

      await general.axios
        .post("/v3/base/newindex/getKeyUdid", {
          key,
          udid,
          ua: userAgent,
        })
        .then(({ data: resData }) => {
          console.log("游戏详情---获取udid信息-----", resData);
          let { status, data } = resData;

          if (status.succeed) {
            setUdid(data.udid || "");
          }
        })
        .catch((error) => Dialog.error("setKeyUdid " + error.message));
    }
  };

  const [colour, setColour] = useState();
  const scroll = useScroll();

  const { run: _setColour } = useThrottleFn(
    (value) => {
      setColour(value);
    },
    { wait: 10 }
  );
  useEffect(() => {
    if (scroll && scroll.top) {
      let opacity = Math.abs(scroll.top) / 40;
      if (opacity > 1) {
        opacity = 1;
      }
      _setColour("rgba(255,255,255, " + opacity + ")");
    } else {
      _setColour("#202737");
    }
  }, [scroll, props.active]);

  useEffect(() => {
    history.listen((location) => {
      // console.log("请求路由路径变化了", location);
      Dialog.close();
    });
  });

  useUpdateEffect(() => {
    if (props.active && init) {
      if (scroll.top) {
        let opacity = Math.abs(scroll.top) / 40;
        if (opacity > 1) {
          opacity = 1;
        }
        setColour("rgba(255,255,255, " + opacity + ")");
        props.setTitle(
          <span style={{ opacity: opacity }}>
            {game?.game_name_main || game?.game_name}
          </span>
        );
      } else {
        setColour("#202737");
        props.setTitle(
          <span style={{ opacity: 0 }}>
            {game?.game_name_main || game?.game_name}
          </span>
        );
      }
    }
    if (props.active) {
      if (scroll?.top < -80) {
        load();
      }
    }
  }, [scroll, props.active]);

  const [routerIndex, setRouterIndex] = useState(
    parseInt(props.query.page) || 0
  );
  const [swiper, setSwiper] = useState(null);
  useEffect(() => {
    if (swiper) {
      swiper.update();
    }
  }, [props.active, swiper]);
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(routerIndex);
    }
  }, [routerIndex, swiper]);

  const ref = useRef(null);

  // 安卓环境下载游戏
  const downloadAndroid = useLockFn(async () => {
    Dialog.close();
    Dialog.loading();

    if (!game?.maiyou_gameid) {
      Dialog.error("缺少必要参数gameid，请重试");
      return;
    }

    let kid = "";
    if (storageLocal.has("activeParentKid")) {
      // 是竞价时，后端会将kid与vid绑定，返回kid；不是竞价时，直接返回kid
      kid = await getKidCallback({
        game_id: game?.maiyou_gameid,
        bind_vid: storageLocal.has("jjAgentShow") ? 1 : 2,
        download_kid: storageLocal.get("activeParentKid"),
      });
    }

    let appId = "991701";
    let time = new Date().getTime().toString();

    let iosObjData = null;

    if (game?.new_sdk_version == 'v4' || game?.new_sdk_version == "v3") {
      let remarkObj = {
        agent: localStorage.getItem("agent") || "x7z1",
        channel: localStorage.getItem("agent") || "x7z1",
      }

      if (storageLocal.has("tgm_uuid")) {
        remarkObj.vid = storageLocal.get("tgm_uuid");
      } else if (kid) {
        remarkObj.kid = kid;
      }
      console.log('remarkObj---', remarkObj);

      iosObjData = {
        appid: appId,
        agent: localStorage.getItem("agent") || "x7z1",
        device_type: "android",
        game_id: game?.maiyou_gameid,
        remark: CryptoJS.enc.Base64.stringify(
          CryptoJS.enc.Utf8.parse(`${JSON.stringify(remarkObj)}`)
        ),
        signature_type: 'v4',
        subpackage_type: "9917",
        timestamp: time,
        version: "",
        depart: "info",
      };
    } else {
      let tgmudid = await asecAgentData(kid, 1, 2);

      iosObjData = {
        appid: appId,
        agent: tgmudid,
        device_type: "android",
        game_id: game?.maiyou_gameid,
        remark: CryptoJS.enc.Base64.stringify(
          CryptoJS.enc.Utf8.parse(`{"agent":"${tgmudid}"}`)
        ),
        signature_type: "v1",
        subpackage_type: "9917",
        timestamp: time,
        version: "",
        depart: "info",
      };
    }

    general.axios
      .post("/handle/subpackage", {
        ...iosObjData,
        sign: sortEncodeAndHash(iosObjData),
      })
      .then((res) => {
        console.log("下载---", res);

        let resInfo = res.data;
        if (resInfo.code !== 200) {
          Dialog.close();
          data.interval = undefined;

          return Dialog.error(resInfo.msg);
        }

        Dialog.close();

        let data = res.data.data;
        if (data.subpackageDownload) {
          window.location.href = data.subpackageDownload;
        }
      })
      .catch((error) => {
        data.interval = undefined;

        Dialog.close();
        Dialog.error(error);
      });
  });

  const reserve = () => {
    setGame({ ...game, is_reserved: !game.is_reserved });
    general.axios
      .post(game.is_reserved ? "/v3/cancelReserveGame" : "/v3/reserveGame", {
        id: game?.maiyou_gameid,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          Dialog.success("操作成功");
        }
      })
      .catch((err) => {
        Dialog.error("reserveGame " + err.message);
      });
  };

  const data = useReactive({
    auto: undefined,
    super: undefined,
    intercept: undefined,
    interceptCall: undefined,
    btns: undefined,
    interceptCallback: undefined,
  });

  useEffect(async () => {
    console.log("有auto啦啦啦啦啦啦啦啦~~~~");
    if (params.auto && data.auto === undefined) {
      console.log("设置auto啦啦啦啦啦啦啦啦~~~~");
      let uri = new URI(window.location.hash.substring(1));
      let query = uri.query(true);

      if (query.appDownload) {
        setUdid(query.udid);
      }

      if (!storageLocal.has("tgm_uuid")) {
        Dialog.loading();
        await getUuidCallback();
        Dialog.close();

        if (storageLocal.has("tgm_uuid")) {
          behaviorTrigger("custom");
          behaviorTrigger("browsing");
        }
        data.auto = params.auto;
      } else {
        if (storageLocal.has("tgm_uuid")) {
          behaviorTrigger("custom");
          behaviorTrigger("browsing");
        }
        data.auto = params.auto;
      }
    }
  }, [params.auto, data.auto]);

  useEffect(() => {
    data.btns =
      (downloadSigning ||
        (iosBtnShow && game?.downButton?.Super) ||
        game?.status == 0) &&
      game?.cloud_support_type === "sq" &&
      game?.cloudDisabled === 0 &&
      (mobileDetect.is("iPhone") ||
        mobileDetect.is("iPad") ||
        mobileDetect.match("Mac OS") ||
        navigator.userAgent == "app" ||
        navigator.userAgent == "uniapp");
  }, [game?.cloudDisabled, downloadSigning, iosBtnShow]);

  // 拦截
  const intercept = (type, callback) => {
    console.log(type, callback);
    data.intercept = type;
    data.interceptCallback = callback;
  };

  const [udidSync, setUdidSync] = useLocalStorageState(
    `udid_sync_${dayjs().format("YYYYMMDDHHmm")}`
  );

  // 节流effect
  useThrottleEffect(async () => {
    console.log("进入详情页面");
    if (udidSync) {
      return;
    }
    setUdidSync(true);

    if (udid && !config.udid_usable) {
      await general.axios
        .post("/v3/base/common/getConfig")
        .then(({ data: resData }) => {
          let { status, data } = resData;
          if (status.succeed) {
            setConfig({ ...config, udid_usable: data.udid_usable });
          }
        })
        .catch((error) => console.error(error));
    }
    setUdidSync(true);
  }, [key, udid, config.udid_usable, udidSync]);

  const [standalone] = useLocalStorageState("standalone");

  // 6级游戏下载上报
  const searchGameDownClick = async () => {
    if (
      sessionStorage.getItem("downParentKid") &&
      sessionStorage.getItem("clickGameId") == game.maiyou_gameid
    ) {
      // 同步当前等级kid
      let kid = await getKidCallback();
      storageLocal.set("activeParentKid", kid);

      let reamrk = {
        game_download_time: dayjs().unix(),
        game_download: game.game_name,
      };
      userClickReport({
        target_action_type: "search",
        parent_id: sessionStorage.getItem("downParentKid"),
        kid,
        level: 6,
        action_code: "search_game_download",
        remark: JSON.stringify(reamrk),
      });

      sessionStorage.removeItem("downParentKid");
      sessionStorage.removeItem("clickGameId");
    }
  };

  // 免签名下载
  const [giftShow, setGiftShow] = useState(false);
  const [isClick, setIsClick] = useState(true);
  const signingDownload = async (num) => {
    console.log("下载游戏免签名");

    if (!storageLocal.has("tgm_uuid")) {
      Dialog.loading();
      await getUuidCallback();
      Dialog.close();

      if (storageLocal.has("tgm_uuid")) {
        behaviorTrigger("custom");
        behaviorTrigger("browsing");
        if (!num) {
          noSignFun();
        }
      } else {
        if (!num) {
          noSignFun();
        }
      }
    } else {
      if (storageLocal.has("tgm_uuid")) {
        behaviorTrigger("custom");
        behaviorTrigger("browsing");
      }
      if (!num) {
        noSignFun();
      }
    }
  };

  const noSignFun = async () => {
    // 检测是否在Safari浏览器中打开
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isSafari) {
      Dialog.loading();

      const route = URI(location.pathname + location.search + location.hash)
        .addQuery("agent", agent)
        .addQuery("key", key)
        .addQuery("userid", localStorage.getItem("user_id") || "")
        .addQuery("username", localStorage.getItem("username") || "")
        .addQuery("token", localStorage.getItem("token") || "")
        .addQuery("standalone", true)
        .addQuery("appDownload", true)
        .addQuery("bd_vid", storageLocal.get("bd_vid"))
        .addQuery("uuid", storageLocal.get("tgm_uuid"))
        .toString();

      console.info(
        "app下载---------------",
        URI(window.location.href).hash(route).toString()
      );
      uni.postMessage({
        data: {
          routeUrl: URI(window.location.href).hash(route).toString(),
        },
      });

      setTimeout(() => {
        let uri = new URI(window.location.hash.substring(1));
        let query = uri.query(true);
        query.agent = agent;
        query.key = key;
        query.userid = localStorage.getItem("user_id") || "";
        query.username = localStorage.getItem("username") || "";
        query.token = localStorage.getItem("token") || "";
        query.standalone = true;
        query.appDownload = true;
        query.bd_vid = storageLocal.get("bd_vid");
        query.uuid = storageLocal.get("tgm_uuid");
        console.log("app下载query---------------", query);

        uri.query(query);
        console.warn(uri.toString());
        Dialog.close();
        history.replace(uri.toString());
      }, 1000);

      return;
    }

    if (isClick) {
      setIsClick(false);
      setGiftShow(true);

      let data = {};
      data.game_id = game?.maiyou_gameid || gameData?.maiyou_gameid;
      data.app_id = game?.game_id || gameData?.game_id;

      let kid = "";
      if (storageLocal.has("activeParentKid")) {
        kid = await getKidCallback({
          game_id: game?.maiyou_gameid || gameData?.maiyou_gameid,
          bind_vid: storageLocal.has("jjAgentShow") ? 1 : 2,
          download_kid: storageLocal.get("activeParentKid"),
        });
      }

      data.ag = await asecAgentData(kid, 1);

      general.axios
        .get("/v3/base/game/selfsigndownload", {
          params: {
            ...data,
          },
        })
        .then((res) => {
          console.log("下载免签名包体", res);
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
            return;
          }
          if (storageLocal.has("tgm_uuid")) {
            behaviorTrigger("downloadpkg");
          }

          window.location.href = data.url;
          // setTimeout(() => {
          //   Dialog.close();
          // }, 3000);
          setIsClick(true);
        })
        .catch((err) => {
          setIsClick(true);
          // Dialog.close();
          // Dialog.error('getGameDetail ' + err.message);
        });
    }
  };

  // 点击至尊版下载
  const location = useLocation();
  const downloadGame = _.throttle(async (num) => {
    Dialog.loading();
    await getUdidVal();
    console.log("至尊版下载99999988888------");

    if (!storageLocal.has("tgm_uuid")) {
      await getUuidCallback();
      Dialog.close();

      if (storageLocal.has("tgm_uuid")) {
        behaviorTrigger("custom");
        behaviorTrigger("browsing");
      }
    } else {
      Dialog.close();
      if (storageLocal.has("tgm_uuid")) {
        behaviorTrigger("custom");
        behaviorTrigger("browsing");
      }
    }

    if (num) return;

    // 检测是否在Safari浏览器中打开
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isSafari) {
      Dialog.loading();

      const route = URI(location.pathname + location.search + location.hash)
        .addQuery("agent", agent)
        .addQuery("key", key)
        .addQuery("userid", localStorage.getItem("user_id") || "")
        .addQuery("username", localStorage.getItem("username") || "")
        .addQuery("token", localStorage.getItem("token") || "")
        .addQuery("standalone", true)
        .addQuery("appDownload", true)
        .addQuery("bd_vid", storageLocal.get("bd_vid"))
        .addQuery("uuid", storageLocal.get("tgm_uuid"))
        .addQuery("activeKid", storageLocal.get("activeParentKid"))
        .toString();

      console.info(
        "app下载---------------",
        URI(window.location.href).hash(route).toString()
      );
      uni.postMessage({
        data: {
          routeUrl: URI(window.location.href).hash(route).toString(),
        },
      });

      setTimeout(() => {
        let uri = new URI(window.location.hash.substring(1));
        let query = uri.query(true);
        query.agent = agent;
        query.key = key;
        query.userid = localStorage.getItem("user_id") || "";
        query.username = localStorage.getItem("username") || "";
        query.token = localStorage.getItem("token") || "";
        query.standalone = true;
        query.appDownload = true;
        query.bd_vid = storageLocal.get("bd_vid");
        query.uuid = storageLocal.get("tgm_uuid");
        query.activeKid = storageLocal.get("activeParentKid");
        console.log("app下载query---------------", query);

        uri.query(query);
        console.warn(uri.toString());
        Dialog.close();
        history.replace(uri.toString());
      }, 1000);

      return;
    }

    if (game?.specialized?.button_name) {
      Dialog.welfare(
        game.specialized.pop_title,
        <div
          dangerouslySetInnerHTML={{
            __html: game.specialized.content,
          }}
        ></div>,
        () => {
          console.log("前往领取");
          window.location.href = game.specialized.url;
        },
        () => {
          console.log("----------");
          if (game.specialized.is_show_down == 1) {
            intercept("super", () => (data.super = true));
            spm(`game.${game?.maiyou_gameid}.download`);
          }
        },
        {
          btn: "前往领取",
          btnDown: game.specialized.is_show_down == 1 ? "直接下载" : "",
        }
      );
    } else {
      intercept("super", () => (data.super = true));
      spm(`game.${game?.maiyou_gameid}.download`);
    }
  }, 3000);

  let [topHeight, setTopHeight] = useState(100);
  const navRef = useRef();
  const barRef = useRef();

  const [serverShow, setServerShow] = useState(false);
  const [jurisdictionShow, setJurisdictionShow] = useState(false);

  return (
    <>
      <div
        className={`game-detail ${navigator.userAgent == "app" || navigator.userAgent == "uniapp"
          ? "no-video"
          : ""
          }`}
        ref={ref}
      >
        {game && !props.loading ? (
          <>
            <div className="game-body">
              <div
                className="status-bar-background statusBar"
                ref={barRef}
                style={{
                  backgroundImage: colour
                    ? `linear-gradient(${colour},${colour})`
                    : "linear-gradient(rgba(204, 204, 204, 0.95),rgba(204, 204, 204, 0))",
                }}
              />

              <div
                className="game-nav fixed"
                ref={navRef}
                style={colour ? { backgroundColor: colour } : null}
              >
                <div
                  className="game-nav-item leftIcon"
                  onClick={() => general.history.goBack()}
                >
                  {colour == "#202737" ? (
                    <img src="/resources/detail/back-white.png" alt="" />
                  ) : (
                    <img src="/resources/detail/back-black.png" alt="" />
                  )}
                </div>

                <div className="game-nav-item-container">
                  {router.map((item, index) => {
                    let count = 0;
                    let show = true;
                    if (item.id == "comment") {
                      count = game?.game_comment_num;
                    } else if (item.id == "tool") {
                      count = game?.cloud_hanging_up?.num || 0;

                      if (count < 1) {
                        show = false;
                      }
                    }

                    return (
                      show && (
                        <div
                          key={index}
                          className={
                            "game-nav-item game-nav-" +
                            item.id +
                            " " +
                            (routerIndex == index ? "active" : "")
                          }
                          style={{
                            color: colour == "#202737" ? "#fff" : "#000",
                          }}
                          onClick={() => {
                            $("html,body").animate({ scrollTop: 0 }, 200);
                            setRouterIndex(index);
                          }}
                        >
                          <div className="text">
                            {item.name}
                            {count && count > 0 ? (
                              <div
                                className="count"
                                style={{
                                  color: colour == "#202737" ? "#fff" : "#000",
                                }}
                              >
                                {count > 99 ? "99+" : count}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              </div>

              <div
                className="game-main"
                style={{ paddingTop: topHeight + "px" }}
              >
                <Swiper
                  allowTouchMove={false}
                  onSwiper={setSwiper}
                  onSlideChange={(swiper) => setRouterIndex(swiper.activeIndex)}
                >
                  {router.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className={
                          "game-main-item game-main-" +
                          item.id +
                          " " +
                          (routerIndex === index ? "active" : "")
                        }
                      >
                        <Active active={props.active && routerIndex === index}>
                          <item.component
                            active={props.active && routerIndex === index}
                            game={
                              game
                                ? game
                                : { game: { game_id: props.query.id } }
                            }
                            setGame={setGame}
                            load={load}
                            setServerShow={setServerShow}
                            setJurisdictionShow={setJurisdictionShow}
                          />
                        </Active>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div className="game-operate">
              {
                init && <div
                  className={`btns ${data.btns ? "multiple" : ""}`}
                  style={{
                    backgroundImage: data.btns
                      ? "url(/resources/game/btn-more.png)"
                      : "none",
                  }}
                >
                  {/* H5游戏-开始玩 */}
                  {game.game_species_type == 3 ? (
                    <>
                      <NavLink
                        className="btn super-btn"
                        user={true}
                        escape={true}
                        // game.h5_link  ${game.h5_link}
                        // https://sdk-h5.bestgame99.com/game?gameId=${ game.maiyou_gameid }&agent=${agent}&gameOrigin=9917
                        to={`${game.new_sdk_version == "v3"
                          ? `${game.h5_link}&osInfo=${udid || localStorage.getItem("key")
                          }&action=POP`
                          : `${game.game_url.android_url}&screen=${game.screen_orientation}`
                          }`}
                        iframe={{ title: game.game_name }}
                        onClick={() => searchGameDownClick()}
                      >
                        开始玩
                      </NavLink>
                    </>
                  ) : game.status == 0 ? (
                    <>
                      {/* 首发提醒 新游首发 */}
                      <NavLink className="btn btn-reserve" onClick={reserve}>
                        {game.is_reserved ? (
                          <h1>取消提醒</h1>
                        ) : (
                          <>
                            <h2>开启首发提醒</h2>
                            <p>
                              {dayjs
                                .unix(game.starting_time)
                                .format("MM-DD HH:mm")}
                              首发
                            </p>
                          </>
                        )}
                      </NavLink>
                    </>
                  ) : (
                    <>
                      {/* iOS */}
                      {mobileDetect.is("iPhone") ||
                        mobileDetect.is("iPad") ||
                        mobileDetect.match("Mac OS") ||
                        navigator.userAgent == "app" ||
                        navigator.userAgent == "uniapp" ? (
                        <>
                          {/* 云玩 */}
                          {game?.cloud_support_type === "sq" &&
                            game?.cloudDisabled === 0 ? (
                            <>
                              <NavLink
                                className="btn btn-cloud"
                                user={true}
                                onClick={async () => {
                                  if (!storageLocal.has("tgm_uuid")) {
                                    Dialog.loading();
                                    await getUuidCallback();
                                    Dialog.close();

                                    if (storageLocal.has("tgm_uuid")) {
                                      behaviorTrigger("custom");
                                      behaviorTrigger("browsing");
                                    }
                                  } else {
                                    Dialog.close();
                                    if (storageLocal.has("tgm_uuid")) {
                                      behaviorTrigger("custom");
                                      behaviorTrigger("browsing");
                                    }
                                  }

                                  searchGameDownClick();
                                  intercept("cloud", playCloudGame);
                                  spm(`game.${game?.maiyou_gameid}.cloud`);
                                }}
                              >
                                <div className="icon">
                                  <img
                                    src="/resources/game/cloud.png"
                                    alt="云玩"
                                  />
                                </div>

                                <div className="text">云玩</div>
                              </NavLink>
                            </>
                          ) : null}

                          {/* 免签名下载 企业签 */}
                          {downloadSigning && (
                            <>
                              {(() => {
                                // 是否需要登录才可下载
                                let user = config.ios_guest_downloadable !== true;
                                if (
                                  user &&
                                  !navigator.standalone &&
                                  !standalone
                                ) {
                                  user = !udid;
                                }
                                return (
                                  <NavLink
                                    className="btn"
                                    style={{ padding: "5px 0" }}
                                    // user={
                                    //   user && agent !== "3rem" && !needLogin
                                    // }
                                    user={false}
                                    onClick={async (e) => {
                                      console.log("免签名下载999999999999999");
                                      await searchGameDownClick();

                                      if (
                                        user &&
                                        agent !== "3rem" &&
                                        !needLogin &&
                                        !general.isLogin() &&
                                        !params.noLogin
                                      ) {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        signingDownload(9);

                                        sessionStorage.setItem("isHaveBack", "");
                                        setShowLogin(true);
                                        document.body.style.overflow = "hidden";

                                        return;
                                      }

                                      signingDownload();
                                      spm(`game.${game?.maiyou_gameid}.download`);
                                    }}
                                  >
                                    <span className="text">下载(推荐)</span>
                                    {game.game_size?.ios_size && (
                                      <div className="size">
                                        {game.game_size?.ios_size}
                                      </div>
                                    )}
                                  </NavLink>
                                );
                              })()}
                            </>
                          )}

                          {/* 至尊版下载 超级签 */}
                          {iosBtnShow && game.downButton?.Super && (
                            <>
                              {(() => {
                                let user = config.ios_guest_downloadable !== true;
                                if (
                                  user &&
                                  !navigator.standalone &&
                                  !standalone
                                ) {
                                  user = !udid;
                                }
                                return (
                                  <NavLink
                                    className="btn super-btn"
                                    style={{ padding: "5px 0" }}
                                    // user={
                                    //   user && agent !== "3rem" && !needLogin
                                    // }
                                    user={false}
                                    onClick={async (e) => {
                                      console.log("超级签下载999999999999999");
                                      await searchGameDownClick();

                                      if (
                                        user &&
                                        agent !== "3rem" &&
                                        !needLogin &&
                                        !general.isLogin() &&
                                        !params.noLogin
                                      ) {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        downloadGame(9);

                                        sessionStorage.setItem("isHaveBack", "");
                                        setShowLogin(true);
                                        document.body.style.overflow = "hidden";
                                        return;
                                      }

                                      downloadGame();
                                    }}
                                  >
                                    {game.specialized?.button_name ? (
                                      <>
                                        <span className="text">
                                          {game.specialized.button_name}
                                        </span>
                                        {game.game_size?.ios_size && (
                                          <div className="size">
                                            {game.game_size?.ios_size}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <div className="text">至尊版下载</div>
                                        {game.game_size?.ios_size && (
                                          <div className="size">
                                            {game.game_size?.ios_size}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </NavLink>
                                );
                              })()}
                            </>
                          )}
                        </>
                      ) : (
                        // 安卓
                        <>
                          {game.specialized?.button_name ? (
                            <div
                              className="btn"
                              onClick={async () => {
                                await searchGameDownClick();

                                Dialog.welfare(
                                  game.specialized.pop_title,
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: game.specialized.content,
                                    }}
                                  ></div>,
                                  () => {
                                    console.log("前往领取");

                                    window.location.href = game.specialized.url;
                                  },
                                  () => {
                                    console.log("----------");
                                    if (game.specialized.is_show_down == 1) {

                                      downloadAndroid();
                                      spm(`game.${game?.maiyou_gameid}.download`);
                                    }
                                  },
                                  {
                                    btn: "前往领取",
                                    btnDown:
                                      game.specialized.is_show_down == 1
                                        ? "直接下载"
                                        : "",
                                  }
                                );
                              }}
                            >
                              <span className="text">
                                {game.specialized.button_name}
                              </span>
                            </div>
                          ) : (
                            <div
                              className="btn"
                              style={{ padding: "5px 0" }}
                              onClick={async () => {
                                await searchGameDownClick();

                                downloadAndroid();
                                spm(`game.${game?.maiyou_gameid}.download`);
                              }}
                            >
                              <span className="text">下载</span>
                              <div className="size">
                                {game.game_size?.android_size}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              }


              <div className="game-help-wrapper">
                <Link to="/game/questionList" className="game-help">
                  下载安装有问题
                  <img
                    src="/resources/four-three/game-detail/click.png"
                    alt=""
                  />
                </Link>

                <Link to="/service" className="game-help help-contact">
                  联系客服
                  <img
                    src="/resources/four-three/game-detail/contact.png"
                    alt=""
                  />
                </Link>
              </div>
            </div>
          </>
        ) : (
          <div className="game-skeleton">
            <div className="a" />
            <div className="b">
              <img src={imgPlaceholder.default} />
            </div>
          </div>
        )}

        {routerIndex === 1 && (
          <div className="comment-goto">
            <Link to={"/comment/submit?id=" + game.comment_topic_id}>
              <img
                src="/resources/four-three/game-detail/comment.png"
                alt=""
                className="comment-goto-icon"
              />
            </Link>
          </div>
        )}

        {data.auto && game ? (
          <>
            <Require
              reject={() => (data.auto = false)}
              type={data.auto === "desktop" ? "cloud" : data.auto}
            >
              <Auto
                game={game}
                type={data.auto === "desktop" ? "cloud" : data.auto}
                close={() => (data.auto = false)}
                callback={
                  data.auto === "cloud" || data.auto === "desktop"
                    ? () => playCloudGame("auto", null, data.auto === "desktop")
                    : () => (data.super = true)
                }
                superGo={() => (data.super = true)}
                cloud={() => playCloudGame("auto")}
              />
            </Require>
          </>
        ) : null}
        {data.super ? (
          <>
            <Require reject={() => (data.super = false)}>
              <Super game={game} close={() => (data.super = false)} />
            </Require>
          </>
        ) : null}
        {data.intercept ? (
          <>
            <Require
              reject={() => (data.intercept = false)}
              type={data.intercept}
            >
              <Intercept
                game={game}
                type={data.intercept}
                close={() => (data.intercept = false)}
                callback={data.interceptCallback}
                superGo={() => (data.super = true)}
                cloud={() => playCloudGame("confirm")}
              />
            </Require>
          </>
        ) : null}
      </div>

      {game && !props.loading && (
        <CSSTransition in={giftShow} timeout={250} unmountOnExit={true}>
          <div className="gift-detail">
            <div className="gift-mask" />
            <div
              className="gift-container"
              style={{
                height: "auto",
                maxHeight: "100vh",
              }}
            >
              <div className="gift-top" style={{ borderBottom: "none" }}>
                <div className="down-title"></div>
                <img
                  style={{ height: "16px", padding: " 0 10px" }}
                  src="/resources/game/close.png"
                  alt=""
                  onClick={() => {
                    setGiftShow(false);
                  }}
                />
              </div>

              <div className="nosign-game-tips">
                <p>游戏打包中请稍后，待弹出安装后即可安装！</p>
                <p style={{ color: "#FF3C3C" }}>
                  游戏安装完成后需根据以下步骤授权
                </p>
              </div>

              <div
                className="gift-main nosign-game"
                style={{ marginTop: "10px" }}
              >
                <div className="down-desc" style={{ paddingBottom: "16px" }}>
                  <p className="down-every">
                    1.打开设置，选择通用-VPN与设备管理
                  </p>

                  <div className="nosign-tips-img">
                    <img src="/resources/download/sign01.png" alt="" />
                    <img src="/resources/download/sign02.png" alt="" />
                  </div>

                  <p className="down-every" style={{ marginTop: "22px" }}>
                    2.找到游戏对应的授权，信任后即可
                  </p>

                  <div className="nosign-tips-img">
                    <img src="/resources/download/sign03.png" alt="" />
                    <img src="/resources/download/sign04.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      )}

      <CSSTransition in={serverShow} timeout={250} unmountOnExit={true}>
        <div className="server-region-content">
          <div
            className="server-mask"
            onClick={() => {
              setServerShow(false);
            }}
          />
          <div className="server-main">
            <div className="gift-top">
              <div className="down-title" style={{ paddingLeft: "46px" }}>
                开服表
              </div>
              <img
                style={{ width: "16px", height: "16px" }}
                src="/resources/game/close.png"
                alt=""
                onClick={() => {
                  setServerShow(false);
                }}
              />
            </div>
            <Server game={game} />
          </div>
        </div>
      </CSSTransition>

      <CSSTransition in={jurisdictionShow} timeout={250} unmountOnExit={true}>
        <div className="server-region-content">
          <div
            className="server-mask"
            onClick={() => {
              setJurisdictionShow(false);
            }}
          />
          <div className="server-main">
            <div style={{ position: "relative", paddingBottom: "16px" }}>
              <div className="gift-top">
                <div className="down-title">权限信息</div>
              </div>
              <div
                className="jur-main"
                dangerouslySetInnerHTML={{
                  __html: game?.game_control_info?.authority_info,
                }}
              ></div>
              <div className="jur-btn">
                <div
                  className="btn-main"
                  onClick={() => {
                    setJurisdictionShow(false);
                  }}
                >
                  我知道了
                </div>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>

      {newuserPopup && newuserPopup.image && (
        <div className="act-data">
          <div className="container">
            <NavLink
              to={
                newuserPopup.jump_type == 2
                  ? `${newuserPopup.jump_value}`
                  : `/game?mid=${newuserPopup.jump_value}`
              }
              iframe={
                newuserPopup?.jump_value?.startsWith("http")
                  ? { title: newuserPopup.title }
                  : undefined
              }
              user={newuserPopup.verify_login == 1 ? true : false}
              onClick={() => {
                setNewuserPopup(null);
              }}
            >
              <div className="img">
                <Image src={newuserPopup.image} alt="" />
              </div>
            </NavLink>
            <div className="close" onClick={() => setNewuserPopup(null)}>
              X
            </div>
          </div>
        </div>
      )}
    </>
  );
};
